module.exports = __webpack_public_path__ + "img/jiajuhuanxin.06c949a9.png";